/** biome-ignore-all lint/style/useNamingConvention: allow snake case */
import {INIT_APP} from '~/common/fabric/constants';
import {SET_EVITE_EVENT} from '~/common/fabric/reducers/eviteEvent/constants';
import {UPDATE_INVITATION_SUMMARY} from '~/ViewInvitation/reducers/constants';
import {UPDATE_GIFT_OPTIONS, UPDATE_PLEDGELING_OPTIONS} from './constants';

const initialState = {
  gift_registry_name: '',
  gift_registry_note: '',
  gift_registry_urls: [],
  gift_registry_type: '',
  saving: false,
  options: {
    event_option_show_gifting: !window.isPartyPassUser && !window.isProUser,
    event_option_enable_photo_sharing: false,
    event_option_enable_host_photo_gallery: false,
  },
  showGifting: true,
  pledgeling_data: {
    Crowdfund: {},
    Organization: {},
  },
  upgraded: false,
};

export const pledgeling = (state, action = {}) => {
  switch (action.payload.beneficiary_type) {
    case 'Crowdfund': {
      if (!('purpose' in action.payload)) {
        return {...state, Crowdfund: {}};
      }

      const {
        beneficiary_type: pledgelingBeneficiaryType,
        purpose: pledgelingPurpose,
        goal: pledgelingGoal,
        ...rest
      } = action.payload;

      return {
        ...state,
        Crowdfund: {
          ...state.Crowdfund,
          pledgeling_beneficiary_type: pledgelingBeneficiaryType,
          pledgeling_purpose: pledgelingPurpose.toString(),
          pledgeling_goal: pledgelingGoal,
          ...rest,
        },
      };
    }

    case 'Organization': {
      if (!('beneficiary_uuid' in action.payload)) {
        const {event_id, host_id, pledgeling_data_item_id, additional_data} = state.Organization;

        return {
          ...state,
          Organization: {
            event_id,
            host_id,
            pledgeling_data_item_id,
            additional_data,
          },
        };
      }

      const {
        beneficiary_type: pledgelingBeneficiaryType,
        beneficiary_uuid: pledgelingUuid,
        beneficiary_id: pledgelingId,
        goal: pledgelingGoal,
        ...rest
      } = action.payload;

      return {
        ...state,
        Organization: {
          ...state.Organization,
          pledgeling_beneficiary_type: pledgelingBeneficiaryType,
          pledgeling_goal: pledgelingGoal.toString(),
          pledgeling_id: pledgelingId.toString(),
          pledgeling_uuid: pledgelingUuid,
          ...rest,
        },
      };
    }

    default:
      return state;
  }
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_PLEDGELING_OPTIONS: {
      const {pledgeling_data} = state;
      return {...state, pledgeling_data: pledgeling(pledgeling_data, action)};
    }
    case UPDATE_INVITATION_SUMMARY: {
      return {
        ...state,
      };
    }
    case UPDATE_GIFT_OPTIONS:
      return {...state, ...action.payload};
    case SET_EVITE_EVENT: {
      const {
        gift_registry_name,
        gift_registry_note,
        gift_registry_urls,
        options,
        pledgeling_data,
        gift_registry_type,
      } = action.payload;
      const {event_option_show_gifting: showGifting} = options;

      return {
        ...state,
        gift_registry_name,
        gift_registry_urls,
        gift_registry_type,
        gift_registry_note,
        options,
        // We had some events written with bad pledgeling_data, so we are fixing that up here.
        pledgeling_data: pledgeling_data || initialState.pledgeling_data,
        showGifting,
      };
    }
    case INIT_APP: {
      if (action.payload.event) {
        const {
          gift_registry_name,
          gift_registry_note,
          gift_registry_urls,
          pledgeling_data,
          options,
          gift_registry_type,
        } = action.payload.event;
        const {event_option_show_gifting} = options;

        return {
          ...state,
          gift_registry_name,
          gift_registry_note,
          gift_registry_type,
          gift_registry_urls,
          options,
          showGifting: event_option_show_gifting,
          // We had some events written with bad pledgeling_data, so we are fixing that up here.
          pledgeling_data: pledgeling_data || initialState.pledgeling_data,
        };
      }
      return state;
    }
    default:
      return state;
  }
};
